/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Card, styled } from '@mui/material';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Instruction from '../components/endUser/CW/Instruction';
import QuestionCW from '../components/endUser/QuestionCw';
import TableCW from '../components/endUser/TableCw';
import TableFilter from '../components/endUser/TableFilter';
import { useAppDispatch, useAppSelector } from '../app/Hooks';
import {
	API_STATUS_CONSTANT,
	BASIC_CONSTANT,
} from '../constants/StepConstants';
import {
	IDashboardQueStatusReqType,
	ITransferUniversalDashBoardData,
	IType,
} from '../types/CommonTypes';
import {
	getQuestionnaireData,
	getQuestionnaireDetailsCWAPIStatus,
	getTodoMessage,
	questionnaireData,
} from '../redux/QuestionnarieUserSlice';
import GenericModalPopup from '../components/common/GenericModalPopup';
import { questionnaireAPIKeys } from '../utils/ApiKeys';
import {
	addPageViewEventForGA,
	getUserAgentBrowser,
	getUserAgentOS,
} from '../utils/CommonMethods';
import { Numbers } from '../utils/Enum';
import { commonLabels } from '../utils/CommonLabels';
import {
	selectUniversalDashboardResponse,
	selectUniversalDashboardResponseStatus,
	setTransferDashboardDataResponse,
	TransferUniversalDashboardData,
} from '../redux/TransferUniversalDashboardDataSlice';
import { configurationData } from '../redux/SurveySlice';

const StyledCard = styled(Card)({
	width: '80%',
	marginLeft: '8%',
	marginBottom: '5%',
	borderRadius: '16px',
	padding: '2.33%',
	paddingTop: '30px',
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	height: 'auto',
	justifyContent: 'center',
	boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.06)',
});

const CWQuestionnairePage = function CWQuestionnairePage() {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const [isSelf, setIsSelf] = useState(false);
	const questionData = useAppSelector(questionnaireData);
	const { id: questionnaireId } = useParams();
	const questionnaireDetailsCWAPIStatus = useAppSelector(
		getQuestionnaireDetailsCWAPIStatus
	);
	const [isGenericModalOpen, setGenericModalOpen] = useState(false);
	const genericModalMsg = useAppSelector(getTodoMessage);
	const configs = useAppSelector(configurationData);
	// dashboard page entry & exit changes
	const [pageEntryEventRegistered, setPageEntryEventRegistered] =
		useState(false);
	const [
		pageInactivityExitDashboardEventRegistered,
		setPageInactivityExitDashboardEventRegistered,
	] = useState(false);
	const universalTransferDashboardDataResponse = useAppSelector(
		selectUniversalDashboardResponse
	);
	const universalTransferDashboardDataResponseStatus = useAppSelector(
		selectUniversalDashboardResponseStatus
	);
	const recordPageEntryEvent = () => {
		const currLogInUserDetails = JSON.parse(
			`${localStorage.getItem('userDetails')}`
		);
		if (
			currLogInUserDetails?.visitEndTime &&
			currLogInUserDetails?.reActivityEvent !== 'loading'
		) {
			localStorage.setItem(
				'userDetails',
				JSON.stringify({
					...JSON.parse(`${localStorage.getItem('userDetails')}`),
					reActivityEvent: 'loading',
				})
			);
			setPageEntryEventRegistered(true);
			const univeralDashboardPayload: ITransferUniversalDashBoardData = {
				apiUrl: `${process.env.REACT_APP_DASHBOARD_API_BASE_URL}Pagevisit/entry`,
				apiType: 'POST',
				apiBody: {
					PageTitle: commonLabels.END_USER,
					PageSubTitle: questionData?.data?.questionnaireCode,
					PageURL: window.location.href,
					id: null,
					IdSession: currLogInUserDetails?.idSession ?? null,
					browser: getUserAgentBrowser(),
					os: getUserAgentOS(),
					visitStartTime: new Date().toISOString(),
					visitEndTime: null,
					userEmailId:
						configs?.user?.userEmailId ?? currLogInUserDetails?.userEmailId,
				},
			};
			dispatch(TransferUniversalDashboardData(univeralDashboardPayload));
		}
	};
	const recordInactivityPageExitEvent = () => {
		const currLogInUserDetails = JSON.parse(
			`${localStorage.getItem('userDetails')}`
		);
		if (!currLogInUserDetails?.visitEndTime) {
			setPageInactivityExitDashboardEventRegistered(true);
			dispatch(setTransferDashboardDataResponse(API_STATUS_CONSTANT.IDLE));
			const univeralDashboardPayload: ITransferUniversalDashBoardData = {
				apiUrl: `${process.env.REACT_APP_DASHBOARD_API_BASE_URL}Pagevisit/entry`,
				apiType: 'POST',
				apiBody: {
					PageTitle: commonLabels.END_USER,
					PageSubTitle: questionData?.data?.questionnaireCode,
					PageURL: window.location.href,
					id: currLogInUserDetails?.id ?? null,
					IdSession: currLogInUserDetails?.idSession ?? null,
					browser: getUserAgentBrowser(),
					os: getUserAgentOS(),
					visitStartTime: currLogInUserDetails?.visitStartTime ?? null,
					visitEndTime: new Date().toISOString(),
					userEmailId:
						configs?.user?.userEmailId ?? currLogInUserDetails?.userEmailId,
				},
			};
			dispatch(TransferUniversalDashboardData(univeralDashboardPayload));
		}
	};

	const trackUserActivity = () => {
		window.addEventListener('load', resetTimer, true);
		window.addEventListener('mousemove', resetTimer, true);
		window.addEventListener('mousedown', resetTimer, true);
		window.addEventListener('touchstart', resetTimer, true);
		window.addEventListener('touchmove', resetTimer, true);
		window.addEventListener('click', resetTimer, true);
		window.addEventListener('keydown', resetTimer, true);
		window.addEventListener('scroll', resetTimer, true);
		window.addEventListener('wheel', resetTimer, true);
	};

	const removeEventListeners = () => {
		window.removeEventListener('load', resetTimer, true);
		window.removeEventListener('mousemove', resetTimer, true);
		window.removeEventListener('mousedown', resetTimer, true);
		window.removeEventListener('touchstart', resetTimer, true);
		window.removeEventListener('touchmove', resetTimer, true);
		window.removeEventListener('click', resetTimer, true);
		window.removeEventListener('keydown', resetTimer, true);
		window.removeEventListener('scroll', resetTimer, true);
		window.removeEventListener('wheel', resetTimer, true);
	};

	let userEngagementTimeout: NodeJS.Timeout | undefined;
	const resetTimer = () => {
		clearTimeout(userEngagementTimeout);
		//30 secs of inactivity will trigger page exit
		userEngagementTimeout = setTimeout(() => {
			recordInactivityPageExitEvent();
		}, Numbers.thirtyThousand);
		recordPageEntryEvent();
	};

	useEffect(() => {
		trackUserActivity();
		// empty dependency array- for the use effect to be triggered in every render
		// eslint-disable-next-line react-hooks/exhaustive-deps
		() => {
			removeEventListeners();
		};
	}, []);

	useEffect(() => {
		const logInUserDetails = JSON.parse(
			`${localStorage.getItem('userDetails')}`
		);

		if (logInUserDetails?.idSession) {
			const univeralDashboardPayload: ITransferUniversalDashBoardData = {
				apiUrl: `${process.env.REACT_APP_DASHBOARD_API_BASE_URL}Pagevisit/entry`,
				apiType: 'POST',
				apiBody: {
					PageTitle: commonLabels.END_USER,
					PageSubTitle: questionData?.data?.questionnaireCode,
					PageURL: window.location.href,
					id: null,
					IdSession: logInUserDetails?.idSession ?? null,
					browser: getUserAgentBrowser(),
					os: getUserAgentOS(),
					visitStartTime: new Date().toISOString(),
					visitEndTime: null,
					userEmailId:
						configs?.user?.userEmailId ?? logInUserDetails?.userEmailId,
				},
			};
			dispatch(TransferUniversalDashboardData(univeralDashboardPayload));
		}
	}, []);

	useEffect(() => {
		if (
			universalTransferDashboardDataResponse?.id &&
			universalTransferDashboardDataResponse?.visitStartTime
		) {
			setPageEntryEventRegistered(false);
			localStorage.setItem(
				'userDetails',
				JSON.stringify({
					...JSON.parse(`${localStorage.getItem('userDetails')}`),
					visitStartTime:
						universalTransferDashboardDataResponse?.visitStartTime,
					id: universalTransferDashboardDataResponse?.id,
					userEmailId: universalTransferDashboardDataResponse?.userEmailId,
					pageQuestionnaireCodeAsSubTitle:
						questionData?.data?.questionnaireCode,
				})
			);
		}
	}, [universalTransferDashboardDataResponse]);

	useEffect(() => {
		if (
			pageEntryEventRegistered &&
			universalTransferDashboardDataResponseStatus !== 'loading'
		) {
			setPageEntryEventRegistered(false);
			localStorage.setItem(
				'userDetails',
				JSON.stringify({
					...JSON.parse(`${localStorage.getItem('userDetails')}`),
					visitStartTime:
						universalTransferDashboardDataResponse?.visitStartTime,
					visitEndTime: null,
					id: universalTransferDashboardDataResponse?.id,
					reActivityEvent: 'loaded',
					pageQuestionnaireCodeAsSubTitle:
						questionData?.data?.questionnaireCode,
				})
			);
		}
	}, [
		pageEntryEventRegistered,
		universalTransferDashboardDataResponse,
		universalTransferDashboardDataResponseStatus,
	]);

	useEffect(() => {
		if (
			pageInactivityExitDashboardEventRegistered &&
			universalTransferDashboardDataResponseStatus !== 'loading'
		) {
			setPageInactivityExitDashboardEventRegistered(false);
			if (universalTransferDashboardDataResponse?.visitEndTime) {
				localStorage.setItem(
					'userDetails',
					JSON.stringify({
						...JSON.parse(`${localStorage.getItem('userDetails')}`),
						visitStartTime: null,
						visitEndTime: universalTransferDashboardDataResponse?.visitEndTime,
						id: null,
						reActivityEvent: 'loaded',
					})
				);
			}
		}
	}, [
		pageInactivityExitDashboardEventRegistered,
		universalTransferDashboardDataResponseStatus,
		universalTransferDashboardDataResponse,
	]);

	useEffect(() => {
		const url = new URL(window.location.href);
		const urlArray = url.pathname.split('/');

		addPageViewEventForGA(
			'pageview',
			urlArray.length > Numbers.two
				? `/${urlArray[Numbers.one]}/%`
				: url.pathname,
			questionnaireAPIKeys.SinglePageQuestionnaire
		);
	}, []);
	useEffect(() => {
		const endUserReq: IType = {
			id: questionnaireId ? questionnaireId : '',
		};
		dispatch(getQuestionnaireData(endUserReq));
		const dashboardStatusReq: IDashboardQueStatusReqType = {
			questionnaireId: questionnaireId ?? '',
			questionnaireCode: questionData?.data?.questionnaireCode ?? '',
			questionnaireName: questionData?.data?.questionnaireName ?? '',
			userEmail: configs?.user?.userEmailId || '',
			browser: getUserAgentBrowser(),
			os: getUserAgentOS(),
			status: commonLabels.incompleteTxt,
			startDate: questionData?.data?.startDate ?? '',
			dueDate: questionData?.data?.dueDate ?? '',
		};
		dispatch(
			TransferUniversalDashboardData({
				apiUrl: `${process.env.REACT_APP_DASHBOARD_API_BASE_URL}questionnaire/entry`,
				apiType: 'POST',
				apiBody: dashboardStatusReq,
			})
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	useEffect(() => {
		if (questionData?.data?.targetAudience === BASIC_CONSTANT.SELF) {
			setIsSelf(true);
		} else {
			setIsSelf(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [questionData, isSelf]);
	useEffect(() => {
		if (
			questionnaireDetailsCWAPIStatus ===
			API_STATUS_CONSTANT.ERROR_PERMISSION_DENIED
		) {
			setGenericModalOpen(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [questionnaireDetailsCWAPIStatus]);
	const goToHome = () => {
		navigate('/');
		navigate(0);
	};

	return (
		<>
			<Box>
				<Instruction />
			</Box>
			<StyledCard>
				{!isSelf && (
					<Box>
						<TableFilter></TableFilter>
						<TableCW></TableCW>
						<QuestionCW></QuestionCW>
					</Box>
				)}
				{isSelf && (
					<Box>
						<QuestionCW></QuestionCW>
					</Box>
				)}
			</StyledCard>
			{isGenericModalOpen && (
				<GenericModalPopup
					openProp={true}
					msgBody={genericModalMsg}
					mainMsg=""
					rightBtnText={'Go To Home'}
					leftBtnText={''}
					isRightBtnVisible={true}
					isLeftBtnVisible={false}
					rightBtnHandler={goToHome}
					leftBtnHandler={() => {}}
					hideCloseBtn={true}
				/>
			)}
		</>
	);
};
export default CWQuestionnairePage;
